export default __webpack_public_path__ + "static/media/Img2.4682862d.png";